export default "https://assets.stage.yurplan.com/yurplan-v1/dist/msg-box__icon--info.93ce571f8db82995f12ca2e0c708cf12.svg";